import { gql } from '@apollo/client';

// NCP-4545: add or remove a LOB from the ApplicationGroup on the quote page.
// selected=false removes it (audit retained for reuse); selected=true re-adds a
// previously-created LOB or creates a new one (returning redirectApplicationId
// so its Phase-3 survey can be completed first).
export default gql`
  mutation updateLob(
    $applicationGroupId: ObjectID!
    $lobType: String!
    $selected: Boolean!
  ) {
    updateLob(
      applicationGroupId: $applicationGroupId
      lobType: $lobType
      selected: $selected
    ) {
      applicationGroupId
      redirectApplicationId
    }
  }
`;
